<template>
  <Dialog header="Adicionar Usuário" :visible.sync="display" :containerStyle="{ width: '430px' }" :modal="true">
    
    <div class="col-12 mb-4">
      <h6>Nome</h6>
      <InputText type="text" v-model="form.name" class="w-100" />
    </div>

    <div class="col-12 mb-4">
      <h6>E-mail</h6>
      <InputText type="text" v-model="form.email" class="w-100" />
    </div>

    <div class="col-12 mb-4">
      <h6>Senha</h6>
      <InputText type="password" v-model="form.password" class="w-100" />
    </div>

    <div class="col-12 mb-4">
      <h6>Confirmar senha</h6>
      <InputText type="password" v-model="form.password_confirm" class="w-100" />
    </div>

    <template #footer>
      <Button label="Cancelar" icon="pi pi-times" @click="closeModal()" class="p-button-sm p-button-secondary" />
      <Button :label="buttons.add.label" icon="pi pi-check" @click="addUser()" class="p-button-sm p-button-success" :disabled="buttons.add.disabled" />
    </template>
  </Dialog>
</template>

<script>
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'

export default {
  name: 'ModalAdd',

  components: {
    Dialog,
    Button,
    InputText
  },

  data() {
    return {
      form: {
        name: '',
        email: '',
        password: '',
        password_confirm: ''
      },

      buttons: {
        add: {
          label: 'Adicionar',
          disabled: false
        }
      },

      display: false,
      organizationSelected: null,
      organizations: []
    }
  },

  methods: {
    async addUser() {
      if (this.form.password !== this.form.password_confirm) {
        this.$toastr.e('As senhas estão diferentes!', 'Erro')
        return
      }

      this.buttons.add.label = 'Adicionando...'
      this.buttons.add.disabled = true

      await this.$api.post('/users', this.form)
        .then((response) => {
          this.$parent.users.unshift(response.data.user)
          this.$toastr.s('Usuário adicionado com sucesso!', 'Sucesso')
          this.closeModal()     
        })
        .catch((err) => {
          this.$toastr.e(err.response.data.message, 'Erro')
          this.form.password = ''
        })
        .finally(() => {
          this.buttons.add.label = 'Adicionar'
          this.buttons.add.disabled = false
        })
    },

    openModal() {
      this.display = true
    },

    closeModal() {
      this.display = false
    },

    clearFields() {
      this.form.name = ''
      this.form.email = ''
      this.form.password = ''
      this.form.password_confirm = ''
    }
  },

  watch: {
    display(value) {
      if (!value) {
        this.clearFields()
      }
    }
  }
}
</script>

<style></style>